export function readDescription(value: unknown): string | null {
    if (typeof value !== 'string') {
        return null;
    }

    const trimmedDescription = value.trim();

    return trimmedDescription !== '' ? trimmedDescription : null;
}

export function descriptionFieldValue(description: string | null): string {
    return description === null ? '' : description;
}
